import { myGooruAPI } from '@/providers/apis/my-gooru/my-gooru';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { sessionService } from '@/providers/services/auth/session';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import { ref } from 'vue';
import { Vue, Component } from 'vue-property-decorator';
import CreateNewPopUpComponent from '@/components/my-gooru-pages/create-new-nudge-type/create-new-nudge-type';

@Component({
  name: 'nudge-types',
  components: {
    CreateNewPopUpComponent,
  },
})
export default class NudgeTypesPageComponent extends Vue {
  private nudgesList: any = ref([]);
  private searchAccessList: string = '';
  private isLoading: boolean = false;
  private errorMsg = false;
  private searchLoader = false;
  private updatingNudge: any;
  private isEdit: boolean = false;
  private isNudgeListLoading = false;
  private noDataAvailable = false;
  private isNudgeTypeListLoading = false;

  private defaultTenant: any;
  private session: any;

  private nudgeTypesList: any = ref([]);

  private debouncedSearchAccess = this.debounce(
    this.searchAccess.bind(this),
    300,
  );

  private setDefaultImage(index: any) {
    this.nudgesList[index].thumbnail.thumbnailUrl =
      this.nudgesList[index].nudge_id === 'recharge'
        ? '/img/default-images/recharge.svg'
        : '/img/default-images/profile.png';
  }
  private created() {
    this.session = sessionService.getSession();
    this.getNudgeTypesList();
  }

  private async getNudgeTypesList() {
    this.isNudgeTypeListLoading = true;
    try {
      const response: any = await myGooruAPI.fetchNudgeTypes();
      const data = Array.isArray(response.data.data) ? response.data.data : [];
      if (data.length === 0) {
        this.noDataAvailable = true;
      } else {
        const cdnUrls = sessionService.getCdnUrl();
        const contentCdnUrl = cdnUrls.content_cdn_url;
        data.forEach((list: any) => {
          list.thumbnail.icon = list.thumbnail.icon
            ? contentCdnUrl + list.thumbnail.icon
            : `${window.location.origin}${DEFAULT_IMAGES_PATH.assessment}`;
        });
        this.nudgeTypesList = data;
      }
    } finally {
      this.isNudgeTypeListLoading = false;
    }
  }

  private searchAccess() {
    const trimmedSearch = this.searchAccessList.trim();

    if (trimmedSearch && trimmedSearch.length > 3) {
      this.searchLoader = true;
      this.filterNudges(trimmedSearch);
      this.searchLoader = false;
    } else {
      this.getNudgeTypesList();
    }
  }

  private searchAccessListClear() {
    this.searchAccessList = '';

    this.getNudgeTypesList();
    this.isLoading = false;
    this.searchLoader = false;
  }

  private async filterNudges(searchText: string) {
    const lowerCaseSearch = searchText.toLowerCase();
    this.nudgeTypesList = await this.nudgeTypesList.filter(
      (nudge: any) =>
        nudge.title.toLowerCase().includes(lowerCaseSearch) ||
        nudge.key.toLowerCase().includes(lowerCaseSearch),
    );
  }

  private async updateNudgeModal(id: number) {
    const foundNudge = await this.nudgeTypesList.find(
      (nudge: any) => nudge.id === id,
    );
    if (foundNudge) {
      this.updatingNudge = { ...foundNudge };
      this.isEdit = true;
      this.$bvModal.show('create-new-nudge-type');
    }
  }

  private createNudgeModal() {
    this.isEdit = false;
    this.updatingNudge = undefined;
    this.$bvModal.show('create-new-nudge-type');
  }

  private clearUpdatingNudge() {
    this.updatingNudge = undefined;
    this.isEdit = false;
  }

  private debounce(func: (...args: any[]) => void, delay: number) {
    let timer: any;
    return function(this: NudgeTypesPageComponent, ...args: any[]) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
}
